import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { BehaviorSubject } from 'rxjs';
export interface IProductStockData {
    [key: string]: {
        source_code: string;
        quantity: number;
    }[];
}
@Injectable({
    providedIn: 'root'
})
export class ProductConfigurableOptionsStockService {
    stocks: IProductStockData = {};
    loaded$ = new BehaviorSubject<IProductStockData>({});
    constructor(private app: App) { }
    loadStocks(skus: string[]): Promise<IProductStockData> {
        return new Promise(resolve => {
            this.app.request.send(undefined, {
                path: 'product/stock',
                data: {
                    product_skus: skus
                }
            }, (response: IProductStockData) => {
                this.stocks = { ...this.stocks, ...response };
                this.loaded$.next(this.stocks);
                resolve(response);
            }, resolve);
        });
    }
}
